export const blockIconsNavigationArrowForward = (
	<span className='material-symbols-outlined'>arrow_forward</span>
);
